import { useFormikContext } from 'formik';
import * as React from 'react';

import DecisionDetailsList from '../../../common/components/DecisionDetailsList';

// The LA and/or LM can send a satellite application back to the engineer and in the process entered a reason for the decision.
// This component embedded in ApllyForLicence page enables the engineer to view the reason for the decision.
const SatelliteDecisionSection = () => {
  const { values } = useFormikContext<{ decisions: any[] }>();
  return <>{values?.decisions && values.decisions.length > 0 && <DecisionDetailsList decisions={values?.decisions} />}</>;
};

export default SatelliteDecisionSection;
